import type {RegistrationStep} from './types';

export const REGISTER_STEPS: RegistrationStep[] = [
  {title: 'مشخصات کاربری', value: 'GeneralInfo', no: 1},
  {title: 'مدرک شناسایی', value: 'UploadDocuments', no: 2},
  {title: 'اطلاعات فروشگاه', value: 'VendorInfo', no: 3},
  {title: 'اطلاعات حساب بانکی', value: 'BankInfo', no: 4},
  {title: 'احراز هویت', value: 'KycFaceRecognition', no: 5},
  {title: 'آپلود تصویر امضا', value: 'SignContract', no: 6},
  {title: 'اتمام ثبت نام', value: 'Finish', no: 7}
];

export const VALID_REGISTRATION_STEP_VALUES = [
  'GeneralInfo',
  'UploadDocuments',
  'VendorInfo',
  'BankInfo',
  'KycFaceRecognition',
  'SignContract',
  'KycSendOtp',
  'Finish'
];
